export const SET_MANAGERS = "SET_MANAGERS"
export const SET_COORDINATES = "SET_COORDINATES"